import type { CSSProperties } from "react";

/**
 * B8 (28-09-2026): maximale lengte van de notitie bij een taak en bij wachten.
 * Gelijk aan `TIJDLIJN_NOTITIE_MAX_TEKENS` in de backend en aan de kolom
 * `DossierTijdlijnItem.comment` (`VarChar(1500)`).
 */
export const TIJDLIJN_NOTITIE_MAX_TEKENS = 1500;

/** Notitie in een tabelcel: één regel, afgekapt; volledige tekst in `title`. */
export const NOTITIE_IN_TABEL_STIJL: CSSProperties = {
  display: "block",
  maxWidth: "360px",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};
